import { ClockCounterClockwise } from "@phosphor-icons/react";
import { useState } from "react";

import NotEnoughSeats from "features/subscriptions/components/NotEnoughSeatsDialog";

import { SplitButton } from "common/components/SplitButton";

import { useCampaignContext } from "../../../../../context/CampaignContext";
import useCampaignValidation from "../../../../../hooks/useCampaignValidation";
import CampaignStart from "./CampaignStart";

export default function StartCampaignButton() {
  const [isLicensesModalOpen, setIsLicensesModalOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isScheduled, setIsScheduled] = useState<boolean>();

  const { owners } = useCampaignContext();

  const { workerAccountsWithoutSeat, hasInsufficientLicenses } =
    useCampaignValidation(owners);

  function onStartCampaign(shouldSchedule: boolean) {
    if (hasInsufficientLicenses) {
      setIsLicensesModalOpen(true);
      return;
    }

    setIsScheduled(shouldSchedule);
    setIsDialogOpen(true);
  }

  return (
    <>
      <SplitButton
        onClick={() => onStartCampaign(false)}
        dropdownMenuItems={[
          {
            label: "Schedule campaign",
            icon: ClockCounterClockwise,
            onSelect: () => onStartCampaign(true),
          },
        ]}
      >
        Start
      </SplitButton>
      <NotEnoughSeats
        isOpen={isLicensesModalOpen}
        setIsOpen={setIsLicensesModalOpen}
        noSeatAccountIds={workerAccountsWithoutSeat.map(({ id }) => id)}
      />

      <CampaignStart
        isOpen={isDialogOpen}
        isScheduled={isScheduled}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
